import { FilterFn } from '@tanstack/react-table';
import { registerTableFilter } from '../../common/tanstacktable';
import { DataObjectCommentDto } from '../../dataobject';
import {
  CommentValueDateSelectFilterInput,
  CommentValueDateSelectFilterValueType,
} from './CommentValueDateSelectFilterInput';
import {
  getDayjsFromAny,
  getIsoDateFromFormattedDate,
  MAX_TIMESTAMP,
  MIN_TIMESTAMP,
} from '../../common/utils';

declare module '@tanstack/react-table' {
  interface FilterFns {
    commentValueDateSelect: FilterFn<any>;
  }
}

registerTableFilter<DataObjectCommentDto>(
  'commentValueDateSelect',
  (row, columnId, filterValue: CommentValueDateSelectFilterValueType) => {
    const { type, valueDates } = filterValue;

    if (!valueDates || (!valueDates[0] && !valueDates[1])) return true;

    const value = row.renderValue(columnId);
    if (
      value === undefined ||
      value === null ||
      typeof value !== 'string' ||
      value.length === 0
    ) {
      return true;
    }

    // For single and compare types, valueDates will have one or two dates respectively and we can do direct comparison
    // For range type, we need to check if the value falls within the range
    if (type === 'single') {
      return value === valueDates[0];
    } else if (type === 'compare') {
      return value === valueDates[0] || value === valueDates[1];
    } else if (type === 'range') {
      const cell = getDayjsFromAny(value);
      if (!cell?.isValid()) return true;

      const from = getDayjsFromAny(
        getIsoDateFromFormattedDate(valueDates[0]) || MIN_TIMESTAMP,
      )?.startOf('day');
      const toExclusive = getDayjsFromAny(
        getIsoDateFromFormattedDate(valueDates[1]) || MAX_TIMESTAMP,
      )
        ?.add(1, 'day')
        ?.startOf('day');

      return (
        !!from &&
        !!toExclusive &&
        (cell.isSame(from) ||
          (cell.isAfter(from) && cell.isBefore(toExclusive)))
      );
    }

    return true;
  },
  CommentValueDateSelectFilterInput,
);
